import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CalenderIcon } from "@ui/icons/CustomIcons";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect } from "react";
import { Controller, } from "react-hook-form";
import { ErrorWithIcon } from "./ValidationMessage";
export const HDatePicker = React.forwardRef(({ value, name, control, label, backgroundColor = "transparent", disabled = false, onChange, rules, errormsg, size = "medium", variant = "filled", disablePast, disableFuture, timeOfDay = "start", minDate, }, ref) => {
    const [dateValue, setDateValue] = React.useState(value ? dayjs(value) : null);
    const theme = useTheme();
    const datePickerId = `date-custom-field-${name}`;
    useEffect(() => {
        setDateValue(value ? dayjs(value) : null);
    }, [value]);
    const CustomCalendarIcon = () => {
        return _jsx(CalenderIcon, { color: "#00244D", size: 20 });
    };
    return (_jsxs(Box, { width: "100%", id: datePickerId, sx: {
            backgroundColor: backgroundColor,
            borderRadius: 1,
            height: "56px",
        }, children: [_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(DesktopDatePicker, { sx: {
                            width: "100%",
                            background: backgroundColor,
                        }, minDate: minDate, disabled: disabled, label: label ? label : undefined, format: "DD/MM/YYYY", value: field.value ? dayjs(field.value) : null, closeOnSelect: true, onChange: (date) => field.onChange(date?.toDate() || null), disablePast: disablePast, disableFuture: disableFuture, slots: {
                            openPickerIcon: CustomCalendarIcon,
                        }, slotProps: {
                            textField: {
                                size,
                                error: !!errormsg,
                                label: label,
                                variant: "filled",
                                sx: {
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                        position: "relative",
                                        // Placeholder styles
                                        "&.MuiFilledInput-root": {
                                            borderRadius: 1,
                                            border: `1px solid ${theme.palette.grey[300]}`,
                                            backgroundColor: "#FFFFFF",
                                            "&.Mui-focused": {
                                                border: `1px solid ${theme.palette.primary.main}`,
                                            },
                                            "&:before, &::after": {
                                                border: "none !important",
                                            },
                                        },
                                        "& .MuiFilledInput-input": {
                                            borderRadius: 1,
                                        },
                                        "&::placeholder": {
                                            transition: theme.transitions.create(["transform", "font-size"], {
                                                duration: theme.transitions.duration.shortest,
                                            }),
                                            color: disabled
                                                ? theme.palette.text.disabled
                                                : "#00244D99", // Placeholder color
                                        },
                                        // Placeholder transformation on focus
                                        "&:focus-within::placeholder": {
                                            transform: "translateY(-16px)",
                                            fontSize: "12px",
                                            color: theme.palette.primary.main,
                                        },
                                        // Input field border styles
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            border: disabled
                                                ? `1px solid #00244D33`
                                                : `1px solid ${theme.palette.edark.light}`,
                                        },
                                        // Input value color
                                        "& .MuiInputBase-input": {
                                            color: "#00244D", // Text value color
                                        },
                                    },
                                },
                            },
                            popper: {
                                anchorEl: document.getElementById(datePickerId),
                            },
                        } })) }) }), errormsg && _jsx(ErrorWithIcon, { error: errormsg })] }));
});
